import { isStandalone } from '@digital-retail/store-manager';
import { DEFAULT_GROUP_ID } from './constants';

export const mapGroupNames = ({ groups, defaultGroupName }) => {
  return groups.map((group) =>
    group.groupId === DEFAULT_GROUP_ID ? { ...group, groupName: defaultGroupName } : group
  );
};

export const buildViewMoreUrl = ({ appCtx, currentGroup }) => {
  let categoryPath = 'category';
  if (isStandalone(appCtx)) {
    categoryPath = 'lista';
  }
  return `/${appCtx.tenant}/${categoryPath}/${currentGroup?.catalogGroupId}`;
};
